<template>
  <div :class="radioContainerClass">
    <div v-for="label in labels" :key="label.id">
      <DsRadioButton
        :label="label.title"
        :id="label.id"
        :name="name"
        :disabled="disabled"
      />
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import DsRadioButton from '../RadioButton/RadioButton.vue';

export default Vue.extend({
  name: 'DsRadioGroup',
  components: {
    DsRadioButton
  },
  props: {
    id: {
      type: String,
      required: false
    },
    labels: {
      type: Array,
      required: false
    },
    name: {
      type: String,
      required: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    isColumn: {
      type: Boolean,
      required: false
    },
    dark: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    radioContainerClass() {
      if (this.isColumn) {
        return 'ds-radio-button--column';
      }
      else {
        return 'ds-radio-button--row';
      }
    }
  },
  mounted() {
    document.documentElement.setAttribute(
      'data-color-theme',
      this.dark ? 'dark' : ''
    );
  }
});
</script>

<style lang="scss" scoped>
@import '~@ds/styles/RadioGroup.scss';
</style>
